export const getBlogTagFromList = (tagList = [], tagId = '') => {
    let tagItem: any = {};
    for (let i = 0; i < tagList.length; i++) {
        const itemA: any = tagList[i];
        if (itemA.tagUrl === tagId) {
            tagItem = itemA;
            break;
        }
    }
    if (!tagItem.tag && tagList.length) {
        tagItem = tagList[0] || {};
    }
    return tagItem;
};
// 先判断是否自已跳转自己
export const getRedirectUrlHandle = (redirectUrl: string, pathname: string) => {
    if (!redirectUrl) {
        return null;
    }
    if (redirectUrl.includes(pathname)) {
        return null;
    }
    return redirectUrl;
};
